import { Draft, DraftDesignConfiguration } from '@/types';
import { getImageObjectUrl } from '@/utils/upload/imageObjectUrls';
import {
  isDraftConfigurationWithTextOrSpecialText,
  isDraftDesignConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { designUploadModalAction } from '@/redux/modal/actions/designUploadModalAction';
import { dismissModalAction } from '@/redux/modal/actions/dismissModalAction';
import { StoreDispatch } from '@/redux/types';
import { matchTextAgainstBlocklistAction } from '../actions/matchTextAgainstBlocklistAction';
import { removeConfigurationFilterAction } from '../actions/removeConfigurationFilterAction';

export const verifyDraft = (draft: Draft, dispatch: StoreDispatch) => {
  const { configurationIds, configurations } = draft;

  if (!configurationIds || configurationIds.length === 0 || !configurations) {
    return;
  }

  configurationIds.forEach((cid) => {
    const configuration = configurations[cid];
    const text =
      isDraftConfigurationWithTextOrSpecialText(configuration) && configuration.text.content;
    if (text) {
      dispatch(matchTextAgainstBlocklistAction(configuration, text));
    }
  });

  const invalidFilterConfigurations: DraftDesignConfiguration[] = [];
  configurationIds.forEach((cid) => {
    const configuration = configurations[cid];
    // if a filter is configured the filtered design must be already uploaded
    //  or the original image is available
    if (
      isDraftDesignConfiguration(configuration) &&
      configuration.filter &&
      !(configuration.filter.designId || getImageObjectUrl(configuration.design.id))
    ) {
      invalidFilterConfigurations.push(configuration);
    }
  });

  const dismissInvalidFilterConfigurations = () => {
    invalidFilterConfigurations.forEach((configuration) => {
      if (!getImageObjectUrl(configuration.design.id)) {
        dispatch(removeConfigurationFilterAction(configuration));
      }
    });
    dispatch(dismissModalAction);
  };

  if (invalidFilterConfigurations.length) {
    dispatch(
      designUploadModalAction(invalidFilterConfigurations, dismissInvalidFilterConfigurations)
    );
  }
};
